import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import Skeleton from '@material-ui/lab/Skeleton';
import { getContent } from '../../../services';
import { Icons } from '../../atoms';

const Fade = require('react-reveal/Fade');

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: '#f0f0f0',
      minHeight: '100vh',
      padding: '32px 16px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: 100,
      '@media screen and (max-width: 1919px)': {
        minHeight: 'initial',
        padding: '6rem 1rem',
      },
    },
    boxBt: {
      display: 'flex',
      gap: 32,
      maxWidth: 1280,
      width: '100%',
      '@media screen and (max-width: 950px)': {
        flexDirection: 'column-reverse',
      },
      [theme.breakpoints.up(2550)]: {
        maxWidth: 1440,
      },
    },
    textTitle: {
      marginBottom: 32,
      [theme.breakpoints.up(2550)]: {
        fontSize: 60,
      },
    },
    textList: {
      fontSize: 18,
      lineHeight: '1.5em',
      maxHeight: '3em',
      overflow: 'hidden',
      fontWeight: 500,
      [theme.breakpoints.up(2550)]: {
        fontSize: 32,
      },
    },
    textListDetail: {
      fontSize: 20,
    },
    image: {
      height: '40vh',
    },
    [theme.breakpoints.down('sm')]: {
      textList: {
        fontSize: 16,
      },
      textTitle: {
        fontSize: 28,
        marginBottom: 24,
      },
    },
    boxTitle: {
      display: 'flex',
      alignItems: 'center',
      gap: 24,
      cursor: 'pointer',
      transition: '.5s',
      // "&:hover": {
      //   transform: "translate(16px) !important",
      // },
    },
    [theme.breakpoints.down('xs')]: {
      textList: {
        fontSize: 14,
      },
      image: {
        height: '30vh',
      },
      boxTitle: {
        gap: 16,
        // "&:hover": {
        //   transform: "translate(12px) !important",
        // },
      },
    },
    boxListNews: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      gap: 16,
      width: '60%',
      '@media screen and (max-width: 950px)': {
        flexDirection: 'column-reverse',
        width: '100%',
      },
      [theme.breakpoints.up(2550)]: {
        width: '70%',
      },
    },
    boxImage: {
      position: 'relative',
      width: '100%',
      cursor: 'pointer',
      height: 400,
      [theme.breakpoints.up(2550)]: {
        height: 550,
      },
    },
    boxTextImage: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      color: '#FFF',
      background:
        'linear-gradient(to bottom,rgba(0,0,0,0),rgba(0,0,0,0.95) 90%)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      padding: 32,
    },
  })
);

const BeritaHome = ({ isId }: any) => {
  const classes = useStyles();
  const history = useHistory();
  const [loadingState, setLoadingState] = useState(true);
  const [activeState, setActiveState] = useState(0);
  const [beritaState, setBeritaState] = React.useState<any>([]);

  const selectedBerita = beritaState.find((row: any) => row.id === activeState);

  const fetchBerita = async () => {
    try {
      const res = await getContent(4, 4, 1);
      setBeritaState(res.data.rows);
      setActiveState(res.data.rows[0].id);
      setLoadingState(false);
    } catch (err: any) {
      console.error(err.message);
    }
  };

  useEffect(() => {
    fetchBerita();
  }, []);

  return (
    <Box className={classes.root}>
      {loadingState ? (
        <Skeleton
          variant='rect'
          width={'100%'}
          height={42}
          style={{ marginBottom: '3rem', maxWidth: 400 }}
        />
      ) : (
        <Typography
          color='primary'
          variant='h4'
          align='center'
          className={classes.textTitle}
        >
          {isId ? 'Berita Terbaru' : 'Latest News'}
        </Typography>
      )}
      <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
        <Box className={classes.boxBt}>
          {loadingState ? (
            <>
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 16,
                }}
              >
                {[1, 2, 3].map(() => (
                  <Skeleton width={'100%'} variant='rect' height={42} />
                ))}
              </div>
              <Skeleton variant='rect' width={'100%'} height={300} />
            </>
          ) : (
            <>
              <Box className={classes.boxListNews}>
                {beritaState.map((row: any, i: number) => (
                  <Fade right={i % 2 !== 0} left={i % 2 === 0} key={row.id}>
                    <Box
                      onClick={() => setActiveState(row.id)}
                      className={classes.boxTitle}
                      style={{
                        transform:
                          activeState === row.id
                            ? 'translate(12px)'
                            : 'translate(0)',
                      }}
                    >
                      <Box>
                        <Icons.IconNext fill='#fff' secondFill='#E3232A' />
                      </Box>
                      <Typography
                        variant='h5'
                        className={classes.textList}
                        color={
                          activeState === row.id ? 'primary' : 'textPrimary'
                        }
                      >
                        {isId ? row.title_id : row.title_en}
                      </Typography>
                    </Box>
                  </Fade>
                ))}
              </Box>
              <div style={{ width: '100%' }}>
                <Fade right>
                  <Box
                    className={classes.boxImage}
                    onClick={() =>
                      history.push({
                        pathname:
                          '/pusat-media/berita/' + selectedBerita?.title_id,
                        state: beritaState.find(
                          (rowActive: any) => rowActive.id === activeState
                        ),
                      })
                    }
                  >
                    {beritaState.map((row: any) => (
                      <img
                        src={`${process.env.REACT_APP_URL}/images/${row.image}`}
                        alt={row.title_en}
                        className={classes.image}
                        style={{
                          display: activeState === row.id ? 'block' : 'none',
                          objectFit: 'cover',
                          width: '100%',
                          height: '100%',
                        }}
                      />
                    ))}
                    <Box className={classes.boxTextImage}>
                      <Fade bottom>
                        <Typography
                          className={classes.textListDetail}
                          style={{
                            color: '#fff',
                            lineHeight: '1.5em',
                            maxHeight: '3em',
                            overflow: 'hidden',
                          }}
                        >
                          {isId
                            ? selectedBerita?.title_id
                            : selectedBerita?.title_en}
                        </Typography>
                        <Typography
                          style={{
                            color: '#f0f0f0',
                            fontSize: 14,
                            fontWeight: 200,
                          }}
                        >
                          {moment(selectedBerita?.created_at).fromNow()}
                        </Typography>
                      </Fade>
                    </Box>
                  </Box>
                </Fade>
              </div>
            </>
          )}
        </Box>
      </div>
    </Box>
  );
};

export default BeritaHome;
